import React from "react";

const index = () => {
  return <div>blog content</div>;
};

export default index;
